import React, { useState } from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import russianSize from '../../../mocks/sizes/russian-size'
import Table from '../Table'
import Modal from '../Modal'
import sizes from '../../../mocks/sizes'
import GenericSelect from '../GenericSelect'
import styles from './size.module.scss'
import P from '../Typography/P'
import classNames from 'classnames'

function WomanSize(props) {
  const [modalIsOpen, setModalIsOpen] = useState(false)

  const openModal = () => {
    setModalIsOpen(true)
  }
  const closeModal = () => {
    setModalIsOpen(false)
  }
  const { content, current, productName, name, onChange, compact } = props

  const handleChange = (event) => {
    onChange(name, event)
  }

  return (
    <div className={styles.main}>
      <Modal isOpen={modalIsOpen} onRequestClose={closeModal}>
        <React.Fragment>
          <h2 className={styles.tableTitle}>Таблица размеров</h2>
          <Table items={sizes[productName].woman} />
          <div className={styles.norm}>Допустимая норма: ±2 см</div>
        </React.Fragment>
      </Modal>
      <P className={styles.label}>Женский размер</P>
      {compact ? (
        <div className={styles.content}>
          {content.map(({ label, value, disabled }) => (
            <button
              className={classNames(
                styles.buttonCompact,
                current === value && styles.buttonCompactActive
              )}
              disabled={disabled}
              key={value}
              onClick={() => onChange(name, value)}
            >
              {label}
            </button>
          ))}
          <button className={styles.footerCompact} onClick={() => openModal()}>
            Открыть таблицу размеров
          </button>
        </div>
      ) : (
        <GenericSelect
          className={styles.select}
          value={current}
          onChange={handleChange}
          options={content}
          renderValue={(value) => (
            <SelectContainer>
              <div>
                Размер – {content.find((item) => item.value === value).label}
              </div>
              {russianSize[productName] &&
                russianSize[productName].woman &&
                russianSize[productName].woman[value] && (
                  <div className={styles.russianSize}>
                    {russianSize[productName].woman[value]}
                  </div>
                )}
            </SelectContainer>
          )}
          renderOption={(label, value) => {
            return (
              <OptionContainer>
                <div>{label}</div>
                {russianSize[productName] &&
                  russianSize[productName].woman &&
                  russianSize[productName].woman[value] && (
                    <div className={styles.russianSize}>
                      {russianSize[productName].woman[value]}
                    </div>
                  )}
              </OptionContainer>
            )
          }}
          renderFooter={() => (
            <button className={styles.tableLink} onClick={() => openModal()}>
              Открыть таблицу размеров
            </button>
          )}
        />
      )}
    </div>
  )
}

const SelectContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding-right: 10px;
  font-size: 20px;
`

const OptionContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding-right: 21px;
  height: 50px;
  padding-top: 15px;
`

WomanSize.propTypes = {
  productName: PropTypes.string,
  name: PropTypes.string,
  content: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string,
    })
  ),
  current: PropTypes.string,
  compact: PropTypes.bool,
  onChange: PropTypes.func,
}

export default WomanSize
